<div class="banner">
    <img srcset="
    ../../../assets/skeleton/banner/Lidl_giftcard_Header_1920x500_{{currentLanguage}}.jpg 1920w,
    ../../../assets/skeleton/banner/Lidl_giftcard_Header_1440x500_{{currentLanguage}}.jpg 1440w,
    ../../../assets/skeleton/banner/Lidl_giftcard_Header_480x215_{{currentLanguage}}.jpg 480w"
        src="../../../assets/skeleton/banner/Lidl_giftcard_Header_1920x500_{{currentLanguage}}.jpg" alt="">
</div>